import React, { useState } from 'react';

var C = {
  bg: '#0a0f1e', card: '#0d1325', accent: '#3b82f6', tx: '#e2e8f0',
  mid: '#94a3b8', dim: '#64748b', bdr: 'rgba(255,255,255,0.1)',
  ok: '#22c55e', ng: '#ef4444', warn: '#f59e0b',
};

var REBAR = {
  '3':{n:3,db:0.375,a:0.11},'4':{n:4,db:0.500,a:0.20},'5':{n:5,db:0.625,a:0.31},
  '6':{n:6,db:0.750,a:0.44},'7':{n:7,db:0.875,a:0.60},'8':{n:8,db:1.000,a:0.79},
  '9':{n:9,db:1.128,a:1.00},'10':{n:10,db:1.270,a:1.27},'11':{n:11,db:1.410,a:1.56},
  '14':{n:14,db:1.693,a:2.25},'18':{n:18,db:2.257,a:4.00},
};
var STIRRUPS = {
  '3':{n:3,db:0.375,a:0.11},'4':{n:4,db:0.500,a:0.20},'5':{n:5,db:0.625,a:0.31},
};

function getBeta1(fc) {
  if (fc <= 4000) return 0.85;
  if (fc >= 8000) return 0.65;
  return 0.85 - 0.05 * (fc - 4000) / 1000;
}

function runFlexure(p) {
  var b=p.b,d=p.d,fc=p.fc,fy=p.fy,Mu=p.Mu,cover=p.cover;
  var beta1=getBeta1(fc), phi=0.9, rows=[], warns=[];
  var Rn=(Mu*12000)/(phi*b*d*d);
  var m=fy/(0.85*fc);
  var disc=1-2*Rn/fy;
  if(disc<0) return {error:'Section too small for Mu. Increase b or d.',ok:false};

  var rho=(1/m)*(1-Math.sqrt(disc));
  var As_req=rho*b*d;
  var a_req=As_req*fy/(0.85*fc*b);
  var c_req=a_req/beta1;
  var et=0.003*(d-c_req)/c_req;
  var phi_act=0.9, tc=true;
  if(et<0.005){tc=false;phi_act=et>=0.002?0.65+0.25*(et-0.002)/0.003:0.65;warns.push('NOT tension-controlled (et='+et.toFixed(4)+'). Increase depth.');}

  var As_min=Math.max(3*Math.sqrt(fc)*b*d/fy, 200*b*d/fy);
  var rho_max=0.85*beta1*fc/fy*0.003/(0.003+0.005);
  var As_max=rho_max*b*d;
  var As_des=Math.max(As_req, As_min);

  var a_des=As_des*fy/(0.85*fc*b);
  var Mn=As_des*fy*(d-a_des/2)/12000;
  var phiMn=phi_act*Mn;

  var sug=[];
  Object.keys(REBAR).forEach(function(sz){
    var bar=REBAR[sz];
    if(bar.n<4||bar.n>11) return;
    var nb=Math.ceil(As_des/bar.a);
    if(nb>=2&&nb<=8){
      var cs=(b-2*cover-2*0.375-nb*bar.db)/(nb-1);
      if(cs>=Math.max(bar.db,1.0)) sug.push({label:nb+' #'+sz, As:nb*bar.a, cs:cs});
    }
  });

  rows.push({l:'Required As',v:As_req.toFixed(3)+' sq.in.'});
  rows.push({l:'Min As (9.6.1.2)',v:As_min.toFixed(3)+' sq.in.'});
  rows.push({l:'Max As (tension-ctrl)',v:As_max.toFixed(3)+' sq.in.'});
  rows.push({l:'Design As',v:As_des.toFixed(3)+' sq.in.',hi:true});
  rows.push({l:'a',v:a_des.toFixed(2)+' in.'});
  rows.push({l:'c',v:c_req.toFixed(2)+' in.'});
  rows.push({l:'Beta_1',v:beta1.toFixed(2)});
  rows.push({l:'epsilon_t',v:et.toFixed(4)+(tc?' [Tension Ctrl]':' [NOT Tension Ctrl]')});
  rows.push({l:'phi',v:phi_act.toFixed(2)});
  rows.push({l:'phi*Mn',v:phiMn.toFixed(1)+' kip-ft'});

  return {ok:phiMn>=Mu, As_des:As_des, phiMn:phiMn, Mu:Mu, rows:rows, warns:warns, sug:sug,
    summary:phiMn.toFixed(1)+' >= '+Mu.toFixed(1)+' kip-ft', label:'As = '+As_des.toFixed(2)+' sq.in.'};
}

function runShear(p) {
  var b=p.b,d=p.d,fc=p.fc,fyt=p.fyt,Vu=p.Vu,stSz=p.stSz,nLegs=p.nLegs;
  var lam=p.lw?0.75:1.0, phi=0.75, sqfc=Math.sqrt(fc), rows=[], warns=[];

  var Vc=2*lam*sqfc*b*d/1000;
  var phiVc=phi*Vc;
  var req='none', reason='';
  if(Vu<=0.5*phiVc){req='none';reason='Vu <= 0.5*phi*Vc';}
  else if(Vu<=phiVc){req='minimum';reason='Min stirrups required';}
  else{req='design';reason='Stirrups must be designed';}

  var Vs_req=(Vu/phi)-Vc;
  var Vs_max=8*sqfc*b*d/1000;
  if(Vs_req>Vs_max) warns.push('Vs exceeds 8*sqrt(fc)*bw*d. Enlarge section (ACI 22.5.1.2).');

  var st=STIRRUPS[stSz];
  var Av=nLegs*st.a;
  var Avs_min=Math.max(0.75*sqfc*b/fyt, 50*b/fyt);
  var s_min_av=Av/Avs_min;
  var s_vs=Vs_req>0?Av*fyt*d/(Vs_req*1000):null;
  var Vs_th=4*sqfc*b*d/1000;
  var s_code=(Vs_req<=Vs_th)?Math.min(d/2,24):Math.min(d/4,12);

  var s_des=null;
  if(req==='minimum') s_des=Math.min(s_min_av, s_code);
  else if(req==='design') s_des=Math.min(s_vs||999, s_min_av, s_code);

  var Vs_prov=0, phiVn=phiVc;
  if(s_des&&s_des>0){s_des=Math.floor(s_des*2)/2;Vs_prov=Av*fyt*d/(s_des*1000);phiVn=phi*(Vc+Vs_prov);}

  rows.push({l:'Vc',v:Vc.toFixed(2)+' kip'});
  rows.push({l:'phi*Vc',v:phiVc.toFixed(2)+' kip'});
  rows.push({l:'Required Vs',v:Math.max(Vs_req,0).toFixed(2)+' kip'});
  rows.push({l:'Max Vs',v:Vs_max.toFixed(2)+' kip'});
  rows.push({l:'Requirement',v:reason,hi:true});
  if(s_des){
    rows.push({l:'Av provided',v:Av.toFixed(2)+' sq.in.'});
    if(s_vs) rows.push({l:'Spacing from Vs',v:s_vs.toFixed(1)+' in.'});
    rows.push({l:'Spacing from Av,min',v:s_min_av.toFixed(1)+' in.'});
    rows.push({l:'Max code spacing',v:s_code.toFixed(1)+' in.'});
    rows.push({l:'Design spacing',v:s_des.toFixed(1)+' in.',hi:true});
  }
  rows.push({l:'phi*Vn',v:phiVn.toFixed(1)+' kip'});

  var lbl=req==='none'?'No stirrups required':'#'+stSz+' @ '+(s_des?s_des.toFixed(1):'--')+' in.';
  return {ok:phiVn>=Vu, rows:rows, warns:warns,
    summary:phiVn.toFixed(1)+' >= '+Vu.toFixed(1)+' kip', label:lbl};
}

function runCrack(p) {
  var fy=p.fy, cover=p.cover, barSz=p.barSz, b=p.b, As=p.As;
  var bar=REBAR[barSz], rows=[], warns=[];
  var fs=(2/3)*fy;
  var cc=cover;
  var sma=15*(40000/fs)-2.5*cc;
  var smb=12*(40000/fs);
  var sm=Math.min(sma,smb);
  var nb=Math.max(Math.round(As/bar.a),2);
  var actual=(b-2*cover-2*0.375-nb*bar.db)/(nb-1)+bar.db;
  var ok=actual<=sm;
  if(!ok) warns.push('Bar spacing exceeds max. Use more/smaller bars.');

  rows.push({l:'fs = (2/3)*fy',v:fs.toLocaleString()+' psi'});
  rows.push({l:'cc (clear cover)',v:cc.toFixed(2)+' in.'});
  rows.push({l:'15*(40000/fs)-2.5*cc',v:sma.toFixed(1)+' in.'});
  rows.push({l:'12*(40000/fs)',v:smb.toFixed(1)+' in.'});
  rows.push({l:'Max spacing (governing)',v:sm.toFixed(1)+' in.',hi:true});
  rows.push({l:'Est. bars / actual spacing',v:nb+' bars / '+actual.toFixed(1)+' in.'});

  return {ok:ok, rows:rows, warns:warns,
    summary:actual.toFixed(1)+' <= '+sm.toFixed(1)+' in.', label:ok?'Spacing OK':'Spacing NG'};
}

function runDeflection(p) {
  var b=p.b,h=p.h,d=p.d,fc=p.fc,As=p.As,Asc=p.Asc||0,span=p.span,wDL=p.wDL,wLL=p.wLL,cover=p.cover;
  var lam=p.lw?0.75:1.0, rows=[], warns=[];

  var Ec=57000*Math.sqrt(fc), n=29000000/Ec;
  var fr=7.5*lam*Math.sqrt(fc);
  var Ig=b*Math.pow(h,3)/12, yt=h/2;
  var Mcr=fr*Ig/yt/12000;

  var nAs=n*As, nAsc=n*Asc, dc=cover+0.375+0.5;
  var Aq=b/2, Bq=nAs+nAsc, Cq=-(nAs*d+nAsc*dc);
  var kd=(-Bq+Math.sqrt(Bq*Bq-4*Aq*Cq))/(2*Aq);
  var Icr=b*Math.pow(kd,3)/3+nAs*Math.pow(d-kd,2)+nAsc*Math.pow(kd-dc,2);

  var MaDL=wDL*span*span/8, MaLL=wLL*span*span/8, MaT=MaDL+MaLL;

  var calcIe=function(Ma){
    var mc=(2/3)*Mcr;
    if(Ma<=mc||Ma<=0) return Ig;
    var r=mc/Ma, den=1-r*r*(1-Icr/Ig);
    return den<=0?Ig:Math.min(Icr/den,Ig);
  };
  var IeDL=calcIe(MaDL), IeT=calcIe(MaT);

  var dDL=5*(wDL/12)*1000*Math.pow(span*12,4)/(384*Ec*IeDL);
  var dTI=5*((wDL+wLL)/12)*1000*Math.pow(span*12,4)/(384*Ec*IeT);
  var dLL=dTI-dDL;

  var rhoC=Asc/(b*d), xi=2.0, lamD=xi/(1+50*rhoC);
  var dLT=lamD*dDL, dTLT=dLT+dLL;

  var L360=span*12/360, L240=span*12/240;
  var okLL=dLL<=L360, okLT=dTLT<=L240;

  rows.push({l:'Ec',v:(Ec/1000).toFixed(0)+' ksi'});
  rows.push({l:'n = Es/Ec',v:n.toFixed(2)});
  rows.push({l:'fr',v:fr.toFixed(0)+' psi'});
  rows.push({l:'Ig',v:Ig.toFixed(0)+' in.^4'});
  rows.push({l:'Mcr',v:Mcr.toFixed(1)+' kip-ft'});
  rows.push({l:'kd / Icr',v:kd.toFixed(2)+' in. / '+Icr.toFixed(0)+' in.^4'});
  rows.push({l:'Ma,DL / Ma,LL / Ma,total',v:MaDL.toFixed(1)+' / '+MaLL.toFixed(1)+' / '+MaT.toFixed(1)+' kip-ft'});
  rows.push({l:'Ie,DL / Ie,total',v:IeDL.toFixed(0)+' / '+IeT.toFixed(0)+' in.^4'});
  rows.push({l:'Imm. DL / LL',v:dDL.toFixed(3)+' / '+dLL.toFixed(3)+' in.'});
  rows.push({l:'LT multiplier',v:lamD.toFixed(2)+' (xi='+xi+')'});
  rows.push({l:'LT DL (creep+shrink)',v:dLT.toFixed(3)+' in.'});
  rows.push({l:'LL deflection',v:dLL.toFixed(3)+' in. vs L/360 = '+L360.toFixed(3)+' in.',hi:true});
  rows.push({l:'Total LT deflection',v:dTLT.toFixed(3)+' in. vs L/240 = '+L240.toFixed(3)+' in.',hi:true});

  return {ok:okLL&&okLT, rows:rows, warns:warns,
    summary:'LL: '+dLL.toFixed(3)+'/'+L360.toFixed(3)+' | LT: '+dTLT.toFixed(3)+'/'+L240.toFixed(3),
    label:(okLL?'LL OK':'LL NG')+' / '+(okLT?'LT OK':'LT NG')};
}

/* -- styles -- */
var ss = {
  wrap:{background:C.bg,minHeight:'100vh',fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',color:C.tx},
  ctr:{maxWidth:'1100px',margin:'0 auto',padding:'2rem'},
  hdr:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:'1rem',background:'#080c18',margin:'-2rem -2rem 2rem -2rem',padding:'1.5rem 2rem',borderBottom:'1px solid rgba(30,58,95,0.3)'},
  h1:{fontSize:'1.5rem',fontWeight:800,color:'#f1f5f9',margin:0},
  hsub:{fontSize:'0.85rem',color:C.dim,marginTop:'0.25rem'},
  back:{padding:'0.55rem 1.25rem',background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'6px',color:C.tx,fontSize:'0.85rem',fontWeight:600,cursor:'pointer',fontFamily:'inherit'},
  card:{background:C.card,border:'1px solid '+C.bdr,borderRadius:'10px',padding:'1.5rem',marginBottom:'1rem'},
  title:{fontSize:'1rem',fontWeight:700,color:'#f1f5f9',marginBottom:'0.75rem',marginTop:0},
  lbl:{fontSize:'0.8rem',fontWeight:600,color:C.mid,display:'block',marginBottom:'0.3rem'},
  inp:{width:'100%',padding:'0.5rem 0.7rem',background:'rgba(255,255,255,0.04)',border:'1px solid '+C.bdr,borderRadius:'6px',color:C.tx,fontSize:'0.88rem',fontFamily:'inherit',boxSizing:'border-box'},
  sel:{width:'100%',padding:'0.5rem 0.7rem',background:'rgba(255,255,255,0.04)',border:'1px solid '+C.bdr,borderRadius:'6px',color:C.tx,fontSize:'0.88rem',fontFamily:'inherit',boxSizing:'border-box',appearance:'auto'},
  grid6:{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(130px,1fr))',gap:'0.85rem'},
  grp:{display:'flex',flexDirection:'column'},
  chk:{display:'flex',alignItems:'center',gap:'0.5rem',cursor:'pointer',fontSize:'0.84rem',color:C.mid,marginTop:'0.5rem'},
  btn:{width:'100%',padding:'0.75rem',background:C.accent,border:'none',borderRadius:'6px',color:'white',fontWeight:700,fontSize:'0.95rem',cursor:'pointer',fontFamily:'inherit',marginTop:'0.5rem'},
  row:{display:'flex',justifyContent:'space-between',padding:'0.45rem 0',borderBottom:'1px solid '+C.bdr,fontSize:'0.84rem',flexWrap:'wrap',gap:'0.2rem'},
  warnBox:{background:'rgba(245,158,11,0.08)',border:'1px solid rgba(245,158,11,0.3)',borderRadius:'8px',padding:'0.65rem 1rem',fontSize:'0.84rem',color:C.warn,marginTop:'0.5rem'},
  computed:{padding:'0.5rem 0.7rem',background:'rgba(59,130,246,0.1)',border:'1px solid rgba(59,130,246,0.2)',borderRadius:'6px',color:C.accent,fontSize:'0.88rem',fontWeight:700},
};

function StatusBox(props) {
  var ok = props.ok;
  var bg = ok ? 'rgba(34,197,94,0.06)' : 'rgba(239,68,68,0.06)';
  var bdr = ok ? 'rgba(34,197,94,0.25)' : 'rgba(239,68,68,0.25)';
  var color = ok ? C.ok : C.ng;
  return React.createElement('div', {style:{background:bg,border:'2px solid '+bdr,borderRadius:'8px',padding:'0.75rem 1rem',flex:1,minWidth:'140px'}},
    React.createElement('div',{style:{fontSize:'0.75rem',color:C.mid,marginBottom:'0.15rem'}},props.title),
    React.createElement('div',{style:{fontSize:'0.88rem',fontWeight:700,color:color}},props.label),
    React.createElement('div',{style:{fontSize:'0.72rem',color:C.dim,marginTop:'0.15rem'}},props.summary)
  );
}

function DetailBlock(props) {
  var r = props.result;
  if (!r) return null;
  var ok = r.ok;
  var tagBg = ok ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)';
  var tagColor = ok ? C.ok : C.ng;

  return React.createElement('div', {style:ss.card},
    React.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'0.75rem'}},
      React.createElement('h3',{style:{fontSize:'1rem',fontWeight:700,color:'#f1f5f9',margin:0}},props.title),
      React.createElement('span',{style:{display:'inline-block',padding:'0.2rem 0.6rem',borderRadius:'4px',fontSize:'0.78rem',fontWeight:700,background:tagBg,color:tagColor}},ok?'PASS':'FAIL')
    ),
    r.rows && r.rows.map(function(row,i){
      return React.createElement('div',{key:i,style:ss.row},
        React.createElement('span',{style:{color:C.mid}},row.l),
        React.createElement('span',{style:{fontWeight:700,color:row.hi?C.accent:C.tx}},row.v)
      );
    }),
    r.sug && r.sug.length > 0 && React.createElement('div',{style:{marginTop:'0.75rem',paddingTop:'0.75rem',borderTop:'1px solid '+C.bdr}},
      React.createElement('div',{style:{fontSize:'0.84rem',fontWeight:700,color:'#f1f5f9',marginBottom:'0.5rem'}},'Bar Selections'),
      r.sug.map(function(x,i){
        return React.createElement('div',{key:i,style:ss.row},
          React.createElement('span',{style:{fontWeight:700,color:C.tx}},x.label),
          React.createElement('span',{style:{color:C.mid}},'As = '+x.As.toFixed(2)+' sq.in., clear = '+x.cs.toFixed(1)+' in.')
        );
      })
    ),
    r.warns && r.warns.map(function(w,i){return React.createElement('div',{key:i,style:ss.warnBox},w);})
  );
}

export default function ConcreteBeamDesign(props) {
  var onBack = props.onBack;
  var _b=useState(12),b=_b[0],setB=_b[1];
  var _h=useState(24),h=_h[0],setH=_h[1];
  var _cv=useState(1.5),cover=_cv[0],setCover=_cv[1];
  var _fc=useState(4000),fc=_fc[0],setFc=_fc[1];
  var _fy=useState(60000),fy=_fy[0],setFy=_fy[1];
  var _lw=useState(false),lw=_lw[0],setLw=_lw[1];
  var _Mu=useState(150),Mu=_Mu[0],setMu=_Mu[1];
  var _Vu=useState(30),Vu=_Vu[0],setVu=_Vu[1];
  var _sp=useState(20),span=_sp[0],setSpan=_sp[1];
  var _wdl=useState(1.0),wDL=_wdl[0],setWDL=_wdl[1];
  var _wll=useState(1.0),wLL=_wll[0],setWLL=_wll[1];
  var _bs=useState('6'),barSz=_bs[0],setBarSz=_bs[1];
  var _ss=useState('3'),stSz=_ss[0],setStSz=_ss[1];
  var _nl=useState(2),nLegs=_nl[0],setNLegs=_nl[1];
  var _fyt=useState(60000),fyt=_fyt[0],setFyt=_fyt[1];
  var _asc=useState(0),Asc=_asc[0],setAsc=_asc[1];
  var _res=useState(null),results=_res[0],setResults=_res[1];

  var barDb = REBAR[barSz] ? REBAR[barSz].db : 0.75;
  var d = h - cover - 0.375 - barDb / 2;

  var doDesign = function() {
    var fR = runFlexure({b:b,d:d,fc:fc,fy:fy,Mu:Mu,cover:cover});
    var As_use = fR.As_des || 0;
    var sR = runShear({b:b,d:d,fc:fc,fyt:fyt,Vu:Vu,stSz:stSz,nLegs:nLegs,lw:lw});
    var cR = runCrack({fy:fy,cover:cover,barSz:barSz,b:b,d:d,As:As_use});
    var dR = runDeflection({b:b,h:h,d:d,fc:fc,As:As_use,Asc:Asc,span:span,wDL:wDL,wLL:wLL,cover:cover,lw:lw});
    setResults({flex:fR, shear:sR, crack:cR, defl:dR});
  };

  var N = function(e){return parseFloat(e.target.value)||0;};

  return (
    <div style={ss.wrap}><div style={ss.ctr}>
      <div style={ss.hdr}>
        <div>
          <h1 style={ss.h1}>Concrete Beam Design</h1>
          <div style={ss.hsub}>ACI 318-19 - Rectangular beam - All checks</div>
        </div>
        <button style={ss.back} onClick={onBack}>{'<-'} Back to Dashboard</button>
      </div>

      {/* BEAM GEOMETRY */}
      <div style={ss.card}>
        <h3 style={ss.title}>Beam Definition</h3>
        <div style={ss.grid6}>
          <div style={ss.grp}><label style={ss.lbl}>b (in.)</label><input type="number" style={ss.inp} value={b} onChange={function(e){setB(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>h (in.)</label><input type="number" style={ss.inp} value={h} onChange={function(e){setH(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>Cover (in.)</label><input type="number" style={ss.inp} value={cover} step="0.25" onChange={function(e){setCover(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>f'c (psi)</label><select style={ss.sel} value={fc} onChange={function(e){setFc(Number(e.target.value));}}>{[3000,3500,4000,4500,5000,5500,6000,7000].map(function(v){return <option key={v} value={v}>{v.toLocaleString()}</option>;})}</select></div>
          <div style={ss.grp}><label style={ss.lbl}>fy (psi)</label><select style={ss.sel} value={fy} onChange={function(e){setFy(Number(e.target.value));}}><option value={40000}>40,000</option><option value={60000}>60,000</option><option value={80000}>80,000</option></select></div>
          <div style={ss.grp}><label style={ss.lbl}>d (in.)</label><div style={ss.computed}>{d.toFixed(2)}</div></div>
        </div>
        <label style={ss.chk}><input type="checkbox" checked={lw} onChange={function(e){setLw(e.target.checked);}}/>Lightweight concrete (Lam = 0.75)</label>
      </div>

      {/* LOADING */}
      <div style={ss.card}>
        <h3 style={ss.title}>Loading</h3>
        <div style={ss.grid6}>
          <div style={ss.grp}><label style={ss.lbl}>Mu (kip-ft)</label><input type="number" style={ss.inp} value={Mu} onChange={function(e){setMu(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>Vu at d (kip)</label><input type="number" style={ss.inp} value={Vu} onChange={function(e){setVu(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>Span (ft)</label><input type="number" style={ss.inp} value={span} onChange={function(e){setSpan(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>wDL (kip/ft)</label><input type="number" style={ss.inp} value={wDL} step="0.1" onChange={function(e){setWDL(N(e));}}/></div>
          <div style={ss.grp}><label style={ss.lbl}>wLL (kip/ft)</label><input type="number" style={ss.inp} value={wLL} step="0.1" onChange={function(e){setWLL(N(e));}}/></div>
        </div>
      </div>

      {/* REINFORCEMENT */}
      <div style={ss.card}>
        <h3 style={ss.title}>Reinforcement</h3>
        <div style={ss.grid6}>
          <div style={ss.grp}><label style={ss.lbl}>Flex. Bar</label><select style={ss.sel} value={barSz} onChange={function(e){setBarSz(e.target.value);}}>{Object.keys(REBAR).filter(function(k){return REBAR[k].n>=4&&REBAR[k].n<=11;}).map(function(k){return <option key={k} value={k}>#{k}</option>;})}</select></div>
          <div style={ss.grp}><label style={ss.lbl}>Stirrup</label><select style={ss.sel} value={stSz} onChange={function(e){setStSz(e.target.value);}}>{Object.keys(STIRRUPS).map(function(k){return <option key={k} value={k}>#{k}</option>;})}</select></div>
          <div style={ss.grp}><label style={ss.lbl}>Legs</label><select style={ss.sel} value={nLegs} onChange={function(e){setNLegs(Number(e.target.value));}}><option value={2}>2</option><option value={4}>4</option></select></div>
          <div style={ss.grp}><label style={ss.lbl}>fyt (psi)</label><select style={ss.sel} value={fyt} onChange={function(e){setFyt(Number(e.target.value));}}><option value={40000}>40,000</option><option value={60000}>60,000</option></select></div>
          <div style={ss.grp}><label style={ss.lbl}>A's comp (sq.in.)</label><input type="number" style={ss.inp} value={Asc} step="0.1" onChange={function(e){setAsc(N(e));}}/></div>
        </div>
      </div>

      <button style={ss.btn} onClick={doDesign}>Design Beam</button>

      {/* RESULTS */}
      {results && <div style={{marginTop:'1.5rem'}}>

        {results.flex && results.flex.error && <div style={{...ss.card,borderColor:C.ng}}><div style={{color:C.ng,fontWeight:700}}>{results.flex.error}</div></div>}

        {results.flex && !results.flex.error && <div>
          {/* Summary strip */}
          <div style={{display:'flex',gap:'0.75rem',flexWrap:'wrap',marginBottom:'1.25rem'}}>
            <StatusBox ok={results.flex.ok} title="Flexure" label={results.flex.label} summary={'phi*Mn '+results.flex.summary} />
            <StatusBox ok={results.shear.ok} title="Shear" label={results.shear.label} summary={'phi*Vn '+results.shear.summary} />
            <StatusBox ok={results.crack.ok} title="Crack Control" label={results.crack.label} summary={results.crack.summary} />
            <StatusBox ok={results.defl.ok} title="Deflection" label={results.defl.label} summary={results.defl.summary} />
          </div>

          {/* Detail blocks */}
          <DetailBlock title="Flexural Design (ACI Ch. 9 & 22)" result={results.flex} />
          <DetailBlock title="Shear Design (ACI Ch. 9 & 22)" result={results.shear} />
          <DetailBlock title="Crack Control (ACI 24.3.2)" result={results.crack} />
          <DetailBlock title="Deflection (ACI 24.2)" result={results.defl} />
        </div>}
      </div>}

    </div></div>
  );
}
